// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import 'font-awesome/css/font-awesome.css'

Vue.config.productionTip = false

/* 移除移动端点击延迟 */
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

/* vuex与router绑定...虽然不清楚这样究竟是否必要 */
import {sync} from 'vuex-router-sync'

sync(store, router)

/* setup routes */
import setupRoute from './router/setup'

setupRoute()

/* setupApi */
import setupApi from './api/setup'

setupApi()

/* 各种插件导入使用 */
import setupPlugins from './plugins/setup'

setupPlugins()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {App}
})




// WEBPACK FOOTER //
// ./src/main.js